// Global
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
// Components
import Component from 'src/helpers/Component/Component';

import { ComponentProps } from 'lib/types/component-props';
import Headline from 'src/helpers/Headline/Headline';
import BodyCopy from 'src/helpers/BodyCopy/BodyCopy';
export type TechDocChatbotProps =
  Feature.EnterpriseWeb.AndersenWindows.Components.Tool.TechDocChatbot.TechDocChatbot &
    ComponentProps;
const TechDocChatbot = (props: TechDocChatbotProps) => {
  if (!props.fields) {
    return <></>;
  }

  return (
    <Component variant="full" grid="none" dataComponent="tool/techdocchatbot" {...props}>
      <Headline {...props} />
      <BodyCopy {...props} />
    </Component>
  );
};

export default withDatasourceCheck()<TechDocChatbotProps>(TechDocChatbot);
